<template>
  <div class="home">
    <items-table />
  </div>
</template>

<script>
import ItemsTable from "@/components/ItemsTable";

export default {
  components: {
    ItemsTable,
  },
}
</script>

<style scoped>
.home {
  max-width: 90em;
  margin: 1em auto;
}
</style>